import loadingSvg from 'media/img/loading.svg'
import React from 'react';

export default () => <div style={{height:'80px',marginTop:'20px',textAlign:'center'}}><img className="fh" src={loadingSvg} alt=""/></div>;


// WEBPACK FOOTER //
// ./src/common/loading/index.js